import user from 'lib/user';
import games from 'modules/widgets/functions/games';
import isEmpty from 'lodash/isEmpty';
import { config } from 'lib';

const parentActions = {
  getToken: function (data) {
    return user.getToken();
  },
  isLogin: function (data) {
    return user.isLogin();
  },
  getRoomId: function (data) {
    return null;
  },
  getRoomInfo: function (data) {
    return null;
  },
  getParentInfo: function () {
    return {
      clientType: 'PC_V2',
    };
  },
  addSocket: (data) => {
    // 在socket中实现，直接在这里引用会相互依赖，编译报错
    // socket.addBroadcastActions(data.action);
  },
  openGamePopup: function (data) {
    // MM.ui.popup.hide();
    // if (data.data === 'football') {
    //   MM.live.game.football.show();
    // }
    // if (data.data === 'black') {
    //   MM.live.game.box.show();
    // }
    let name = data.data;
    if (name === 'black') {
      name = 'h5BoxNew';
    }
    games.showGame(name);
  },
  openActPopup: function (data) {
    const { act_key, act_name, ...restProps } = data.data || {};
    if (isEmpty(act_key)) {
      return;
    }
    MM.ui.popup.hide();
    injectApp.showComponentPopup({
      title: act_name,
      contentDomId: act_key,
      componentPath: `/${act_key}`,
      componentProps: {
        disableScroll: true,
        height: 650,
        openFrom: 1,
        ...restProps,
      },
    });
  },

  getMemeClientVersion() {
    return window.inPcClient ? config.version : 0;
  },
};

export default parentActions;
